// @flow
import type { Train } from 'mz-sdk/services/train/getTrains'

function trainToString(train: Train) {
  return `${train.train_number} / ${train.origin.display_name} (${train.departure_time}) → ${train.destination.display_name} (${train.arrival_time})`
}

export default trainToString
